import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import Grid from '@mui/material/Grid';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
// import pdf1 from 'assests/Pdf/Oly22-23/Mathematic_olympiad.pdf';
// import pdf1 from 'assests/Pdf/Oly23-24/SOF achievers 2023-24.pdf';


// import pdf2 from 'assests/Pdf/CCA/NPS_YESHWANTHPUR-STATE_RESULT.pdf';
// import pdf3 from 'assests/Pdf/CCA/SCIENCE_OLYPIAD_FOUNDATION_2023-24.pdf';
// import pdf4 from 'assests/Pdf/CCA/SILVER_ZONE_INTERNATIONAL_OLYMPIAD_MEDAL.pdf';
// import pdf5 from 'assests/Pdf/CCA/TERI_Results_2023_24.pdf';
// import pdf6 from 'assests/Pdf/CCA/UNIFIED_COUNCIL_OLYMPIADS_NSTSE_2023_24.pdf';
// import pdf7 from 'assests/Pdf/CCA/All_india_general_knowledge_examination_2023.pdf';






import Container from 'components/Container';
import { Button } from '@mui/material';




const Oly24 = () => {

    const [config, setConfig] = useState({ base_image_url: '' });
    useEffect(() => {
        fetch('/config.json')
            .then(response => response.json())
            .then(data => setConfig(data))
            .catch(error => console.error('Error fetching config:', error));
    }, []);

    const pdf1 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/Scholastic_2024-25/Website_sof.pdf`;
    const pdf2 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/Scholastic_2024-25/NSTSE_MERIT_LIST_2024-25.pdf`;
    const pdf3 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/Scholastic_2024-25/TERI_RESULT_SHEET_2024-25.pdf`;
    const pdf4 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/Scholastic_2024-25/Sliver-Zone-Result-2024-25.pdf`;
    const pdf5 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/Scholastic_2024-25/Logiqids-Result-2024-25.pdf`;


    const theme = useTheme();

    const mock = [
       
        {
            name: '',
            title: 'SOF ACHEVIERS LIST OF 2024-25',
            href:pdf1,
        },
        {
            name: '',
            title: 'UNIFIED COUNCIL- NSTSE 2024-25',
            href:pdf2,
        },
        {
            name: '',
            title: 'TERI GREEN OLYMPIAD EXAM RESULTS 2024-25',
            href:pdf3,
        },
        {
            name: '',
            title: 'SILVER ZONE OLYMPIAD OF MATHEMATICS RESULTS 2024 - 25',
            href:pdf4,
        },
        {
            name: '',
            title: 'LOGIQIDS RESULTS 2024 - 25',
            href:pdf5,
        },

    ];

    return (

        <Container>

            <Box>
                <Box >
                    <Typography
                        sx={{
                            textTransform: 'uppercase',
                        }}
                        gutterBottom
                        color={'text.secondary'}
                        align={'center'}
                        fontWeight={700}
                    >
                        OLYMPIAD 2024-25
                    </Typography>
                </Box>
                <Grid container spacing={2}>
                    {mock.map((item, i) => (
                        <Grid item xs={12} md={4} key={i}>
                            <Box
                                width={0.9}
                                height={0.9}
                                component={Card}
                                boxShadow={0}
                                variant={'outlined'}
                                bgcolor={'alternate.main'}
                            >
                                <CardContent sx={{ padding: 3 }}>
                                    <ListItem component="div" disableGutters sx={{ padding: 0 }}>

                                        <Button
                                            href={item.href} target="_blank">
                                            <ListItemText
                                                sx={{ margin: 0 }}
                                                primary={item.name}
                                                secondary={item.title}
                                                primaryTypographyProps={{
                                                    variant: 'h6',
                                                    fontWeight: 700,
                                                }}
                                                secondaryTypographyProps={{ variant: 'subtitle1' }}
                                            />
                                        </Button>
                                    </ListItem>
                                </CardContent>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Box>

        </Container>

    );
};

export default Oly24;